import { Injectable } from '@angular/core';
import { ApiConstants } from '../../shared/constants/api-constants';
import { UserListLookup } from '../../shared/models/users/user-list-lookup';
import { Observable } from 'rxjs';
import { TrainingRequirement } from '../models/training-requirement';
import { HttpClient } from '@angular/common/http';
import { CreateTrainingRequirementRequest } from '../models/create-training-requirement-request';

@Injectable({
  providedIn: 'root'
})
export class TrainingRequirementService {

  constructor(private httpClient : HttpClient) {
   }

  getTrainingRequirementUsersLookUp(trainingRequirement: TrainingRequirement): Observable<UserListLookup[]> {
    return this.httpClient.post<UserListLookup[]>(ApiConstants.TrainingRequirementUserList_Api, trainingRequirement);
  }

  createTrainingRequirementForUsers(trainingRequirementRequest : CreateTrainingRequirementRequest) : Observable<string[]> {
    return this.httpClient.post<string[]>(ApiConstants.CreateTrainingRequirement_Api, trainingRequirementRequest); 
  }

}
